// extracted by mini-css-extract-plugin
module.exports = {"Container":"PartnerLogo_Container__2-504","Image":"PartnerLogo_Image__1o3Ak"};